/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-undef */
import React from "react";
import styled from "styled-components";

const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: black;
`;

export const Audio = ({ attribute, controls = false, playing = true }) => {
  const extension = _.get(attribute, ["extension"]);
  const path = _.get(attribute, ["path"]);

  return (
    <Container>
      <audio
        autoPlay={playing}
        controls={controls}
        type={`audio/${extension}`}
        src={`${REACT_APP_API_ENDPOINT}/${path}`}
      />
    </Container>
  );
};
